import { Component, OnInit, OnDestroy } from '@angular/core';
import { Response } from '@angular/http';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs/Rx';
import { EventManager, ParseLinks, PaginationUtil, JhiLanguageService, AlertService } from 'ng-jhipster';

import { AutorisationBnbaccess } from './autorisation-bnbaccess.model';
import { AutorisationBnbaccessService } from './autorisation-bnbaccess.service';
import { ITEMS_PER_PAGE, Principal } from '../../shared';
import { PaginationConfig } from '../../blocks/config/uib-pagination.config';

@Component({
    selector: 'jhi-autorisation-bnbaccess',
    templateUrl: './autorisation-bnbaccess.component.html'
})
export class AutorisationBnbaccessComponent implements OnInit, OnDestroy {
autorisations: AutorisationBnbaccess[];
    currentAccount: any;
    eventSubscriber: Subscription;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private autorisationService: AutorisationBnbaccessService,
        private alertService: AlertService,
        private eventManager: EventManager,
        private principal: Principal
    ) {
        this.jhiLanguageService.setLocations(['autorisation']);
    }

    loadAll() {
        this.autorisationService.query().subscribe(
            (res: Response) => {
                this.autorisations = res.json();
            },
            (res: Response) => this.onError(res.json())
        );
    }
    ngOnInit() {
        this.loadAll();
        this.principal.identity().then((account) => {
            this.currentAccount = account;
        });
        this.registerChangeInAutorisations();
    }

    ngOnDestroy() {
        this.eventManager.destroy(this.eventSubscriber);
    }

    trackId (index: number, item: AutorisationBnbaccess) {
        return item.id;
    }



    registerChangeInAutorisations() {
        this.eventSubscriber = this.eventManager.subscribe('autorisationListModification', (response) => this.loadAll());
    }


    private onError (error) {
        this.alertService.error(error.message, null, null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/autorisation/autorisation-bnbaccess.component.ts